import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <p className="font-heading text-7xl font-black text-foreground-200 select-none md:text-9xl">
        404
      </p>
      <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        {t("article.notFound")}
      </h1>
      <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-left-line"></i>
        </span>
        {t("article.backHome")}
      </Link>
    </div>
  );
}